// selectionStore.ts
type Listener = () => void;

function closestWithoutGoingOver(arr: number[], target: number): number | null {
  let closest: number | null = null;

  for (const num of arr) {
    if (num <= target && (closest === null || num > closest)) {
      closest = num;
    }
  }

  return closest;
}

export class SelectionStore {
  private selectedPages = new Set<number>();
  private listeners: Set<Listener> = new Set();

  public setSelectedPages(pages: number[]) {
    this.selectedPages = new Set(pages);
    this.emit();
  }

  public toggle(page: number) {
    if (this.selectedPages.has(page)) this.selectedPages.delete(page);
    else this.selectedPages.add(page);
    this.emit();
  }

  public has(page: number) {
    return this.selectedPages.has(page);
  }

  public subscribe(fn: Listener) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private emit() {
    this.listeners.forEach((fn) => fn());
  }

  public getAll() {
    return Array.from(this.selectedPages);
  }

  public clear() {
    this.selectedPages.clear();
    this.emit();
  }

  public getNearest(page: number) {
    const all = this.getAll();
    return closestWithoutGoingOver(all, page);
  }
}

export const selectionStore = new SelectionStore();
